module.exports = __webpack_public_path__ + "static/media/game-well-circle.d6a8cb14.png";